import React, { useEffect, useState } from 'react';
import './GamesSection.css';
import GameCard from './GameCard';
import { API_URL } from '../config';

function GamesSection({ onGameClick }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGamesFromAPI = async () => {
      try {
        const API_BASE_URL = process.env.REACT_APP_API_URL || API_URL;
        console.log('🎮 Loading featured games from API...');
        
        // Lade die Top 4 neuesten Games nach ReleaseDate
        const response = await fetch(`${API_BASE_URL}/api/games?limit=4&sort=release`);
        
        if (response.ok) {
          const apiGames = await response.json();
          console.log(`✅ Loaded ${apiGames.length} featured games from API`);
          
          // Fallback falls nicht genug featured games vorhanden
          if (apiGames.length < 4) {
            console.log('⚠️ Not enough featured games, loading by homepage order...');
            const fallbackResponse = await fetch(`${API_BASE_URL}/api/games?limit=4&sort=featured`);
            if (fallbackResponse.ok) {
              const fallbackGames = await fallbackResponse.json();
              setGames(fallbackGames.slice(0, 4));
            }
          } else {
            setGames(apiGames.slice(0, 4));
          }
        } else {
          console.warn('⚠️ API failed, using static fallback games');
          setGames([
            { key: 'mario-kart', name: 'Mario Kart', heroUrl: null },
            { key: 'ea-fc', name: 'EA FC', heroUrl: null },
            { key: 'cod', name: 'Call of Duty', heroUrl: null },
            { key: 'clash-royale', name: 'Clash Royal', heroUrl: null }
          ]);
        }
      } catch (error) {
        console.error('Error loading games:', error);
        // Fallback zu statischen Games
        setGames([
          { key: 'mario-kart', name: 'Mario Kart', heroUrl: null },
          { key: 'ea-fc', name: 'EA FC', heroUrl: null },
          { key: 'cod', name: 'Call of Duty', heroUrl: null },
          { key: 'clash-royale', name: 'Clash Royal', heroUrl: null }
        ]);
      } finally {
        setLoading(false);
      }
    };

    loadGamesFromAPI();
  }, []);

  if (loading) {
    return (
      <section className="games-section">
        <div className="game-list-container">
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
            <div style={{ color: '#00d4aa', fontSize: '18px' }}>🎮 Loading games...</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="games-section">
      <div className="game-list-container">
        <div className="game-list">
          {games.map((game, index) => (
            <GameCard
              key={game._id || game.key || index}
              title={game.name || game.title}
              image={game.heroUrl}
              link={`/games/${game.key}`}
              onGameClick={() => onGameClick && onGameClick(game)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default GamesSection;